<template>
  <div class="cc-topbar">
    <div class="cc-topbar-info">
      <h4 class="cc-topbar-title">{{ title }}</h4>
      <p class="cc-topbar-subtitle">{{ subtitle }}</p>
    </div>
    <div class="cc-topbar-actions">
      <button v-if="showHelp" class="cc-export-btn" title="How this works" @click="$emit('help')">
        <i class="fa fa-question-circle"></i> Help
      </button>
      <button class="cc-new-chat-btn" @click="$emit('new-chat')">+ New Chat</button>
      <button class="cc-export-btn" @click="$emit('export')">
        <i class="fa fa-download"></i> Export
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CampaignTopbar',
  props: {
    title: { type: String, default: 'Create Campaign' },
    subtitle: { type: String, default: 'Describe your nudge campaign — AI walks you through audience, content, and send window' },
    showHelp: { type: Boolean, default: false }
  },
  emits: ['new-chat', 'export', 'help']
}
</script>
<style scoped src="./CampaignTopbar.css"></style>



// WEBPACK FOOTER //
// CampaignTopbar.vue?0d2fb0f0